import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import Parse from 'html-react-parser';

import UserAPI from '../../../api/UserAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Display from '../../../util/Display';
import Themes from '../../../util/Themes';

import { FaPencilAlt, FaPhoneSquareAlt, FaRegEnvelope } from 'react-icons/fa';
import Util from '../../../util/Util';

class UserPreview extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.user;
    this.LoggedIn = reactLocalStorage.get(Const.LoggedIn);
    this.authUser = reactLocalStorage.get(Const.LoggedInUser);
    this.id = parseInt(props.match.params.userId);
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
    this.model.fields.theme.options = Themes;
    this.state = { inApiCall: this.id !== 0 };
  }

  componentDidMount() { UserAPI.get(this.id, this.onReceived, this.onFail); }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.user = res;
    this.setState({ ...this.state, inApiCall: false });
  };

  render() {
    const TimeZone = this.user && this.user.zone !== null && this.user.zone !== '' && this.user.zone !== '~~'
      ? this.user.zone.substring(0, this.user.zone.length).split('~') : [''];

    return (
      <div className="sectionlist pt-3 pb-5">
        <div className="container-fluid">
          <div className="row lead-mt">
            <div className="col-md-4">
              {this.user && this.LoggedIn && this.LoggedIn === this.user.id && <h3>Personal Setting</h3>}
            </div>
            <div className="col-md-8 lead-btns-col">
              <span className="action-btns-lg">
                <span className="buttons call" variant="primary">
                  <NavLink to={`/setting/user/add-edit/${this.user && this.user.id}`}><FaPencilAlt /> Update </NavLink>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-2 pb-3 text-center">
              <img src={process.env.PUBLIC_URL + '/images/user.png'} alt="user" className="userimg" />
              <Link to="#"> Change</Link>
            </div>
            <div className="col-md-6  pb-3">
              <h4>{this.user && this.user.name}</h4>
              <p className="">{this.user && Display.ModelLabelValue('role', this.user.role)}</p>
              <p><Link to={`tel:${this.user && this.user.work_phone}`}><FaPhoneSquareAlt /> {this.user && this.user.work_phone} </Link></p>
              <p><Link to={`mailto:${this.user && this.user.work_email}`}><FaRegEnvelope /> {this.user && this.user.work_email} </Link></p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6 preview">
              <h3>User Information</h3>
              <Table className="pstable">
                <tbody>
                  <tr> <td>Name</td> <td>{this.user && this.user.name}</td> </tr>
                  <tr> <td>Username</td> <td>{this.user && this.user.username}</td> </tr>
                  <tr> <td>E-mail</td> <td>{this.user && this.user.work_email}</td> </tr>
                  <tr> <td>Work Phone</td> <td>{this.user && this.user.work_phone}</td> </tr>
                  <tr> <td>Mobile</td> <td>{this.user && this.user.personal_phone}</td> </tr>
                  <tr>
                    <td>Role</td><td>{this.user && Display.ModelLabelValue('role', this.user.role)}</td>
                  </tr>
                  <tr>
                    <td>Reporting Person</td>
                    <td> {this.user && Display.ModelLabelValue('user', this.user.reporting)}</td>
                  </tr>
                  <tr>
                    <td>Time Zone</td>
                    <td> {this.user && Display.ModelLabelValue('zone', Number(TimeZone[0]))}</td>
                  </tr>
                  <tr>
                    <td>Theme</td>
                    <td>
                      {this.user && Display.FieldValue(this.user, 'theme', this.model.fields)}
                    </td>
                  </tr>
                  {this.authUser.package === Const.PackageEnterprise && this.authUser.role === Const.Admin ? <tr>
                    <td>Live Tracking</td>
                    <td>
                      {this.user && this.user.isLiveTracking}
                    </td>
                  </tr> : null}
                </tbody>
              </Table>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 preview">
              <h3>Signature</h3>
              <Table className="pstable">
                <tbody>
                  <tr>
                    <td>{this.user && Parse(this.user.signature ? this.user.signature : '')}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(UserPreview);
